import { styled, Typography, typographyClasses } from '@mui/material'

export const HeaderText = styled(Typography)(() => ({
  color: '#4E5256',
  fontWeight: 600,
  fontSize: '0.875rem',
  lineHeight: '100%',
  marginLeft: '-1rem',
}))

export const ButtonText = styled(Typography)(() => ({
  [`&.${typographyClasses.button}`]: {
    color: '#FFFFFF',
    fontWeight: 600,
    fontSize: '1rem',
    lineHeight: '100%',
    textTransform: 'initial',
    flex: 1,
  },
}))
